module.exports = __webpack_public_path__ + "img/clos-luce-bedroom.5341cac1.jpg";